import React from 'react';
import {Link} from 'react-router-dom';
import Avatar from './Avatar';
import DateSince from './Date';
import Views from './Views';
import Answers from './Answers';
import TagList from './TagList';
import createLink from "../../libs/createLink";
import Like from "./Like/Like";
import Dotdotdot from "react-dotdotdot";
import Dropdown from "./Dropdown";
import Icon from "./Icon";
import {Can} from "../../ability-context";
import Report from "./Report";
import Modal from "./Modal";
import AdvancedEditorStory from "./advanced-editor/AdvancedEditorStory";
import {isNoFollowArticle, isNoFollowProfil} from "../../libs/helper";


class ArticleCardSmallStory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editStory: false,
        };
        
        this.handleReport = this.handleReport.bind(this);
    };

    handleReport(id, message){
        this.props.reportMediaComment(this.props.mediaId, id, {message})
    }

    handleUserId(userId){
        if(typeof this.props.handleUserId === "function"){
            this.props.handleUserId(userId);
        }
    }
    
    render(){
        let title = this.props.title || " ";
        let link = "";
        let relLink = {}

        if(this.props.content !== null){
            link = this.props.kind === "Topic" ? createLink("forumTopic", {category : {slug : this.props.content.forum.slug, _id : this.props.content.forum._id}, topic : {_id : this.props.content._id, slug : this.props.content.slug}}) : createLink('article', {...this.props.owner, article : {_id : this.props.content._id, slug : this.props.content.slug}});
            if(this.props.kind === "Article"){
                relLink = isNoFollowArticle(this.props.content) ? { rel: "nofollow" } : {};
            }
        }
        let isStory = this.props.userStories  ? '' :
            <div className="user-blog" onClick={() => this.handleUserId(this.props.owner._id)}>
                <Link to={`${createLink("stories")}?utilisateur=${this.props.owner._id}`}>Voir toutes ses histoires</Link>
            </div>;
        if (this.props.match && this.props.match.params.userId) {
            isStory = '';
        }
        let hasOwner = this.props.owner !== null && this.props.owner._id;
        let relLinkProfil = isNoFollowProfil(this.props.owner) ? { rel: "nofollow" } : {};
        return (
            <div className="card-article-small">
                <div className="wrapper">
                    <div className="content">
                        <div className="column flex-1">
                            <div className="topline py-8 px-16">
                                <div className="story-thumb">
                                    {hasOwner ? (
                                        <div className="user">
                                            <Link to={createLink("userProfile", this.props.owner)} {...relLinkProfil}>
                                                <Avatar className="user-thumb"
                                                        width={65} height={65}
                                                        avatar={this.props.owner.profile.avatar && this.props.owner.profile.avatar}
                                                        gender={this.props.owner.profile.gender} alt=""/>
                                            </Link>
                                        </div>
                                    ) : (
                                        <div className="user">
                                            <div>
                                                <Avatar className="user-thumb" gender={"guest"} alt=""/>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                {link !== "" ? (
                                    <Link to={{
                                        pathname: link,
                                        state: {
                                            fromStories: true
                                        }
                                    }} className="title-link-articles" {...relLink}>
                                        <Dotdotdot clamp={2} useNativeClamp={false}>
                                            {title}
                                        </Dotdotdot>
                                    </Link>
                                ) : (
                                    <div className="title-link-articles">
                                        <Dotdotdot tagName="h2" clamp={2} useNativeClamp={false}>
                                            {title}
                                        </Dotdotdot>
                                    </div>
                                )}

                                <Can action={"moderation"} subject={this.props} modelName="Story">
                                    <Dropdown align="right" className="mt-4" activableComponent={(
                                        <Icon type="vertical-dots"/>
                                    )}>
                                        <ul className="dropdown-menu">
                                            <Can action={"update"} subject={this.props} modelName="Story">
                                                <li className="menu-item"
                                                    onClick={() => this.setState({editStory: true})}>
                                                    <Icon type="pencil"/> Editer
                                                </li>
                                            </Can>
                                            <Can action={"report"} subject={this.props} modelName="Story">
                                                <li className="menu-item">
                                                    <Icon type="report"/>
                                                    <Report _id={this.props._id}
                                                            kind={"stories"}
                                                            handleReport={this.handleReport}
                                                            title="l'histoire"/>
                                                </li>
                                            </Can>
                                        </ul>
                                    </Dropdown>
                                </Can>
                                <Modal toggle={this.state.editStory} handleClose={()=>this.setState({editStory: false})}>
                                    <AdvancedEditorStory handleClose={()=>this.setState({editStory: false})} storyId={this.props._id} />
                                </Modal>
                                <span className="text small medium-grey py-4 badge dark">
                                    {this.props.status === 0 && (
                                        <div className="badge closed">En attente de validation</div>
                                    )}
                                    {this.props.status === 2 && (
                                        <div className="badge closed">Refuser</div>
                                    )}
                                    
                                    {this.props.status === 1 && !this.props.isUpdate && (
                                        <DateSince
                                            date={this.props.createdAt}
                                            prefix={true}
                                            currentFormat={true}
                                        />
                                    )}

                                </span>
                            </div>
                            <div className={"excerpt"}>
                                <Dotdotdot clamp={4} useNativeClamp={false}>
                                    {this.props.excerpt}
                                </Dotdotdot>
                            </div>
                            <TagList tags={this.props && this.props.tags} type={"tagStory"} owner={this.props.owner} className="mt-auto"/>
                        </div>
                        {hasOwner ? (<div className="user">
                            <div className="infos">
                                <div className="username-time">
                                    Par <Link to={createLink("userProfile", this.props.owner)} {...relLinkProfil}>
                                    {this.props.owner.username}&nbsp;
                                </Link>
                                </div>
                                {isStory}
                            </div>
                        </div>) : (<div className="user">
                                <div className="infos">
                                    <div className="username-time">
                                        Par &nbsp; {this.props.authorName}
                                    </div>
                                    {isStory}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="footer">
                        <Views type="icon" value={this.props.content && this.props.content.count && (this.props.content.count.view || 0)}/>
                        <Answers value={this.props.content && this.props.content.count && (this.props.content.count.comment || 0)}/>

                        {this.props.content !== null && this.props.content._id && this.props.kind === "Article" && <Like isLiked={this.props.isLiked}
                                                                                value={this.props.content.count.like || 0}
                                                                                likeType={"articles"}
                                                                                parentId={this.props.content._id}
                        />}
                    </div>
                </div>
            </div>
        )
    }
}

export default ArticleCardSmallStory;
